import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { useSelector } from 'react-redux';


const StackedColumnChart = ({ report }) => {
      const mode = useSelector((state) => state.darkMode);
  
    const { isdarkMode } = mode;
function prepareEChartLineData(inputData) {
  if (!Array.isArray(inputData)) return { xAxisData: [], seriesChartData: [] };

  const timeMapRef = new Map(); // Map for actual sorting: timestamp => formatted time
  const seriesMap = new Map();  // Key: 'METERNAME-Parameter'

  inputData.forEach((item) => {
    const date = new Date(item.CREATEDON);
    const timestamp = date.getTime(); // Unique numeric value for sorting
    const timeLabel = item.CREATEDON.replace("T"," ")

    timeMapRef.set(timestamp, timeLabel);

    Object.keys(item).forEach((key) => {
      if (["CREATEDON", "METERNAME", "METERID", "SITENAME"].includes(key)) return;

      const seriesKey = `${item.METERNAME}-${key}`;
      if (!seriesMap.has(seriesKey)) {
        seriesMap.set(seriesKey, new Map()); // time => value
      }
      seriesMap.get(seriesKey).set(timestamp, item[key]);
    });
  });

  // Sort time by actual timestamp
  const sortedTimestamps = Array.from(timeMapRef.keys()).sort((a, b) => a - b);
  const xAxisData = sortedTimestamps.map((ts) => timeMapRef.get(ts));

  const seriesChartData = [];
  for (let [name, timeValueMap] of seriesMap.entries()) {
    const data = sortedTimestamps.map((ts) => timeValueMap.get(ts) ?? null);
    seriesChartData.push({
      name,
      type: "bar",
      stack: "total",
      emphasis: { focus: "series" },
      data,
    });
  }

  return { xAxisData, seriesChartData };
}




  const { xAxisData, seriesChartData } = prepareEChartLineData(report);
  //console.log(xAxisData)
  //console.log(xAxisData)
  //console.log(seriesChartData)

const option = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow', // helps with stacked bar tooltip
    },
  },
  // legend: {
  //   top: '5%',
  // },
  legend: {
  type: 'scroll',
  textStyle: {
      color: isdarkMode ? 'white' : 'black'   // Set the legend text color here
    },
  top: '0%',
  orient: 'horizontal',
  left: 'center',   // Centers the legend
  itemGap: 10,      // Adjust spacing between items
  padding: [5, 20], // Optional padding
  width: '80%'      // Prevents it from taking full width
},
dataZoom: [
    {
      type: 'slider',     // Bottom zoom bar
      show: true,
      xAxisIndex: 0,
      start: 0,           // Initial window start %
      end: 100,           // Initial window end %
    },
    {
      type: 'inside',     // Scroll/drag zoom
      xAxisIndex: 0,
      start: 0,
      end: 100,
    },
  ],
  xAxis: {
    type: 'category',
    data: xAxisData,
    axisLabel: {
      rotate: 45,
      color: isdarkMode ? 'white' : 'black'   // X axis label color
    },
    axisLine: {
      lineStyle: {
        color: isdarkMode ? 'white' : 'black' // X axis line color
      }
    }
  },
  yAxis: {
    type: 'value',
    name: 'Value',
    axisLabel: {
      color: isdarkMode ? 'white' : 'black'   // Y axis label color
    },
    axisLine: {
      lineStyle: {
        color: isdarkMode ? 'white' : 'black' // Y axis line color
      }
    }
  },
  series: seriesChartData,
  grid: {
    left: '10%',
    right: '10%',
    bottom: '20%',
  },
};


  return (
  <div className='border rounded-xl p-2 py-4'>
  <ReactECharts option={option} style={{ height: 600 }} />;
  </div>
  )};

export default StackedColumnChart;
